export const CurrencyCodes = {
  USD: 'USD',
  EUR: 'EUR',
  GBP: 'GBP',
  AUD: 'AUD',
  CAD: 'CAD',
  JPY: 'JPY',
  SGD: 'SGD',
  COP: 'COP',
  INR: 'INR'
};